import { MenuNavUtils } from "./MenuNavUtils";
import { MenuNavBase } from "./MenuNavBase";

const MENU_MOBILE = {
    CTAS: '.main-nav__ctas-menu-nav',
    HAMBURGER: '.main-nav__ctas-hamburger-menu',
    BACK: '.main-nav__ctas__mobile-header .btn-menu-back',
    CLOSE: '.main-nav__ctas__mobile-header .btn-menu-close',
    LABEL: '.main-nav__ctas__mobile-header .btn-menu-back label',
    BACKDROP: '.main-nav__backdrop',
    BODY: 'body',
    HTML: 'html'
};

// defined in _general.scss (hide body scroll when menu is open in mobile/tablet)
const ACTIVE_MOBILE_MENU = 'mobile-menu-active'; 
export class MenuMobileNav extends MenuNavBase {
    constructor(domNode) {
        super();

        this.domNode = domNode;
        this.headerHambNode = domNode.querySelector(MENU_MOBILE.HAMBURGER);
        this.headerBackNode = domNode.querySelector(MENU_MOBILE.BACK);
        this.headerCloseNode = domNode.querySelector(MENU_MOBILE.CLOSE);
        this.headerLabelNode = domNode.querySelector(MENU_MOBILE.LABEL);
        this.headerBackdrop = domNode.querySelector(MENU_MOBILE.BACKDROP);
        this.lastScrollPosition = null;
        this.currentMenu = null;
        this.previousMenu = [];

        this.initMenuItems(
            domNode.classList.contains(MENU_MOBILE.CTAS) ?
                domNode :
                domNode.querySelector(MENU_MOBILE.CTAS)
        );
        this.initOpenBackCloseButtons();
    }

    initMenuItems (domNode) {
        domNode.querySelectorAll(':scope > li').forEach((item) => {
            // select all items from main menu
            if (!item.classList.contains('utility-nav')) {
                // for each item in main menu, initialize ctas and sub menues
                const ctaSubMenu = item.querySelector(':scope > a');
                if (ctaSubMenu && MenuNavUtils.hasPopup(ctaSubMenu)) {
                    ctaSubMenu.setAttribute('aria-expanded', false);
                    // with 'active-menu' we can attach submenu behavior on first and second level submenues
                    ctaSubMenu.classList.add('active-menu');
                    // initialize other nested submenues
                    const subMenuContainer = item.querySelector(':scope > div');
                    if (subMenuContainer) {
                        this.initializeSubMenues (subMenuContainer);
                    }
                    // add listener to each ctaSubMenu
                    ctaSubMenu && this.addListener(ctaSubMenu, "click", this.onMenuitemTouch.bind(this), { capture: true });
                }
            }
        });
    }

    initializeSubMenues (domNode) {
        // From level 3, html structure may vary (special UI for those submenu levels)
        // level 2 --------------  case 1- div > ul > li* (One ul with Multiple li)
        // level 3 and others ---  case 1- div > ul > li*  ||  case 2- div > ul* > li

        domNode.querySelectorAll(':scope > ul > li').forEach((item) => {
            // configure class for special styling for 3rd level of submenu
            const nextLevelSubMenuContainer = item.querySelector(':scope > div');

            if (nextLevelSubMenuContainer) {
                nextLevelSubMenuContainer.classList.add('inactive-expanded-menu');
                nextLevelSubMenuContainer.querySelectorAll(':scope > ul').forEach((ulItem) => {
                    // submenus with special styling (+3rd level) hide/show and render in one or two columns
                    if (ulItem.children.length === 0) {
                        ulItem.classList.add('not-visible');
                    } else {
                        const submenuTitle = ulItem.querySelector(':scope a');
                        if (MenuNavUtils.hasPopup(submenuTitle)) {
                            ulItem.classList.add('half-line');
                        } else {
                            ulItem.classList.add('full-line');
                        }
                    }
                });
            }

            const ctaSubMenu = item.querySelector(':scope > a');
            if (ctaSubMenu && MenuNavUtils.hasPopup(ctaSubMenu)) {
                // configure initial state
                ctaSubMenu.setAttribute('aria-expanded', false);
                ctaSubMenu.classList.add('active-menu');
                // initialize other nested submenues as expanded
                domNode.querySelectorAll(':scope > div a').forEach((aItem) => {
                    if (MenuNavUtils.hasPopup(aItem)) {
                        ctaSubMenu.setAttribute('aria-expanded', true);
                    }
                });
                // add event listener
                ctaSubMenu && this.addListener(ctaSubMenu, "click", this.onMenuitemTouch.bind(this), { capture: true });
            }
        });
    }

    onMenuitemTouch (evt) {
        evt && evt.preventDefault && evt.preventDefault();

        // show submenu
        evt.currentTarget.setAttribute('aria-expanded', true);

        // hide siblings from parent
        const siblings = this.getSiblings(evt.currentTarget.parentNode);
        siblings.forEach(item => item.classList.add('inactive'));
        evt.currentTarget.parentNode.classList.remove('inactive');
        evt.currentTarget.parentNode.classList.remove('inactive');
        evt.currentTarget.classList.add('inactive');

        // set title and show back btn
        this.headerBackNode.classList.add('show-btn');
        this.headerLabelNode.textContent = evt.currentTarget.textContent;
        
        if (this.currentMenu) {
            this.previousMenu.push(this.currentMenu);
        }
        this.currentMenu = evt.currentTarget;
    }

    initOpenBackCloseButtons () {
        this.addListener(this.headerHambNode, "click", this.onOpenMenuTouch.bind(this), { capture: true });
        this.addListener(this.headerCloseNode, "click", this.onCloseMenuTouch.bind(this), { capture: true });
        this.addListener(this.headerBackdrop, "pointerdown", this.onCloseMenuTouch.bind(this), { capture: true });
        this.addListener(this.headerBackNode, "pointerdown", this.onBackMenuTouch.bind(this), { capture: true });
    }

    onOpenMenuTouch () {
        this.resetMenuNav();
        this.domNode.classList.add('show-menu');
        const body = document.querySelector(MENU_MOBILE.BODY);
        const html = document.querySelector(MENU_MOBILE.HTML);
        body.classList.add(ACTIVE_MOBILE_MENU);
        html.classList.add(ACTIVE_MOBILE_MENU);
        this.lastScrollPosition = window.scrollY;
        window.scrollTo(0, 0);
    }

    onCloseMenuTouch (evt) {
        evt?.preventDefault();
        this.domNode.classList.remove('show-menu');
        const body = document.querySelector(MENU_MOBILE.BODY);
        const html = document.querySelector(MENU_MOBILE.HTML);
        body.classList.remove(ACTIVE_MOBILE_MENU);
        html.classList.remove(ACTIVE_MOBILE_MENU);
        if (!isNaN(this.lastScrollPosition)) {
            window.scrollTo(0, this.lastScrollPosition);
        }
    }

    getSiblings (node) {
        return [...node.parentNode.children].filter(c => c !== node);
    }

    onBackMenuTouch (evt) {
        evt && evt.preventDefault && evt.preventDefault();

        if(this.currentMenu) {
            const itemObj = this.currentMenu;
            const siblings = this.getSiblings(itemObj.parentNode);
            siblings.forEach(item => item.classList.remove('inactive'));
            itemObj.parentNode.classList.remove('active');
            itemObj.classList.remove('inactive');
            itemObj.setAttribute('aria-expanded', false);

            const prevMenu = this.previousMenu.pop();
            if (prevMenu) {
                this.headerLabelNode.textContent = prevMenu.textContent;
                this.currentMenu = prevMenu;
            } else {
                this.currentMenu = null;
                this.headerBackNode.classList.remove('show-btn');
            }
        }
    }

    clearInactiveMenues() {
        this.domNode.
        querySelectorAll(`${MENU_MOBILE.CTAS} li`).
            forEach(item => { item.classList.remove('inactive'); item.classList.remove('active'); } );

        this.domNode.
        querySelectorAll(`${MENU_MOBILE.CTAS} a`).
            forEach(item => { item.classList.remove('inactive'); item.setAttribute('aria-expanded', false); } );
            
        this.domNode.
        querySelectorAll('.inactive-expanded-menu a').
            forEach(item => { item.setAttribute('aria-expanded', true); } );
    }
    
    clearMenuHeader () {
        this.headerBackNode.classList.remove('show-btn');
        this.headerLabelNode.textContent = '';
    }

    resetMenuNav () {
        this.clearInactiveMenues();
        this.clearMenuHeader();
    }
}